import AccessToken from './AccessToken';
import ImpersonatingUser from './ImpersonatingUser';
import mapAuthenticatedUser, { RawAuthenticatedUser } from './mapAuthenticatedUser';
import mapSubscription, { RawSubscription } from './mapSubscription';

export interface RawAccessToken {
	token: string;
	user: RawAuthenticatedUser;
	impersonatedBy: {
		id: string;
		email: string;
		name: string;
	} | null;
	subscription: RawSubscription | null;
}

export default function mapAccessToken(accessToken: RawAccessToken): AccessToken {
	return new AccessToken(
		accessToken.token,
		mapAuthenticatedUser(accessToken.user),
		accessToken.impersonatedBy !== null
			? new ImpersonatingUser(
					accessToken.impersonatedBy.id,
					accessToken.impersonatedBy.email,
					accessToken.impersonatedBy.name
			  )
			: null,
		accessToken.subscription !== null ? mapSubscription(accessToken.subscription) : null
	);
}
